import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  ActivatedRoute
} from "@angular/router";

import {
  UserInfoService,
  SecurityService,
  GetToken
} from "../services/security.service";
import { HttpService } from "./http.interceptor.service";
// import { Observable } from 'rxjs';
import { Observable } from "rxjs/Observable";
import { SlotDataService } from "../../slots/slots-data.service";
import { LoaderService } from "../loader-spinner/index";
import { Config } from "../../../config";
// import { RequestOptions } from '@angular/http';
import { Http, Headers, RequestOptions } from "@angular/http";
import { SharedService } from "./shared.service";
import { AppointmentsService } from "../../appointments/appointments.service";

@Injectable()
export class IsLoggedIn implements CanActivate {
  constructor(
    private router: Router,
    private userInfoService: UserInfoService,
    private route: ActivatedRoute
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.userInfoService.authToken.get()) {
      this.router.navigate(["settings"]);
      return false;
    }
    return true;
  }
}

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private userInfoService: UserInfoService,
    private securityService: SecurityService,
    private HTTP: HttpService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.securityService
      .requiredAuthorizedUser()
      .map(e => {
        if (e) {
          return true;
        }
      })
      .catch(() => {
        this.router.navigate(["/auth/login"]);
        return Observable.of(false);
      });
  }
}

@Injectable()
export class AllowAppointmenttypePanel implements CanActivate {
public Permission;
  constructor( private userInfoService : UserInfoService,
              private router : Router){}

  canActivate(route : ActivatedRouteSnapshot, state : RouterStateSnapshot)
 {
    var Data = this.userInfoService._info
    this.Permission =  Data['IsManageAppointmentTypesPermission']
    if(this.Permission)
    {
      return true;
    }
    else{
      this.router.navigate(['error']);
    }
  }
}
@Injectable()
export class AllowAppointmentTemplatePanel implements CanActivate {
public Permission;
  constructor( private userInfoService : UserInfoService,
              private router : Router){}

  canActivate(route : ActivatedRouteSnapshot, state : RouterStateSnapshot)
 {
    var Data = this.userInfoService._info
    this.Permission =  Data['IsManageAppointmentTemplatesPermission']
    if(this.Permission)
    {
      return true;
    }
    else{
      this.router.navigate(['error']);
    }
  }
}

@Injectable()
export class AllowAppointmentCalendarPanel implements CanActivate {
public Permission;
  constructor( private userInfoService : UserInfoService,
              private router : Router){}

  canActivate(route : ActivatedRouteSnapshot, state : RouterStateSnapshot)
 {
    var Data = this.userInfoService._info
    this.Permission =  Data['IsManageAppointmentCalendarsPermission']
    if(this.Permission)
    {
      return true;
    }
    else{
      this.router.navigate(['error']);
    }
  }
}

@Injectable()
export class FetchToken implements CanActivate {
  public token;
  public companycode;
  public previousCompanyCode;
  public tempToken;
  public companyDetails;
  public config = new Config();
  constructor(
    private router: Router,
    private userInfoService: UserInfoService,
    private getToken: GetToken,
    private route1: ActivatedRoute,
    private loaderService: LoaderService,
    private HTTP: Http,
    private sharedService: SharedService,
    private appointmentsService: AppointmentsService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // this.previousCompanyCode = localStorage.getItem("companycode");
    this.companycode = route.queryParams.companycode || this.sharedService.getCookie("clientCode");
    this.token = this.sharedService.getCookie("token");
    //   route.queryParams.companycode || localStorage.getItem("companycode");
    // this.tempToken = route.queryParams.token;
    if(route.queryParams.code && route.queryParams.state && route.queryParams.state.toLowerCase() === "returned"){
      let rURL= window.location.href.split("?");
      this.appointmentsService.getToken2(route.queryParams.code,rURL[0]).subscribe(data =>{
        // return this.fetchToken();
        window.open(rURL[0],"_self");
      });
    }
    else if(this.token){
      return this.fetchToken();
    }else{
      if(this.companycode){
        localStorage.setItem("companycode", this.companycode);
        return this.validateCompanyCode(this.companycode);
      } else {
        this.router.navigate(['error']);
      }
    }
  }

  validateCompanyCode(companycode) {
    return this.getToken
      .fetchCompanyDetails(companycode)
      .map(companyDetails => {
        localStorage.setItem("companycode", companyDetails.CompanyCode);
        // this.companyDetails = companyDetails;
        var baseURL = location.href.split("?");
        baseURL.forEach(url => {
          if (url.match("companycode")) {
            companycode = url;
          }
        });
        if (companycode) {
          window.location.replace(
            `${this.config.loginUrl}?companyCode=${this.companycode}&returnUrl=${
              baseURL[0]
            }?${companycode}`
          );
        } else {
          window.location.replace(
            `${this.config.loginUrl}?companyCode=${this.companycode}&returnUrl=${
              baseURL[0]
            }`
          );
        }
        return false;
      })
      .catch(() => {
        this.router.navigate(["error"]);
        localStorage.clear();
        return Observable.of(false);
      });
  }

  fetchToken() {
    return this.getToken
      .fetchUserToken(this.token, this.companycode,false, this.previousCompanyCode)
      .map(e => {
        if (e) {
          return true;
        }
      })
      .catch(() => {
        var baseURL = location.href.split("?");
        var companycode;
        localStorage.clear();
        baseURL.forEach(url => {
          if (url.match("companycode")) {
            companycode = url;
          }
        });
        if (companycode) {
          window.location.replace(
            `${this.config.loginUrl}?companyCode=${this.companycode}&returnUrl=${
              baseURL[0]
            }?${companycode}`
          );
        } else {
          window.location.replace(
            `${this.config.loginUrl}?companyCode=${this.companycode}&returnUrl=${
              baseURL[0]
            }`
          );
        }
        return Observable.of(false);
      });
  }
}

@Injectable()
export class HasAppointmentDetail implements CanActivate {
  public appointmentDetail;
  public appointmentCode;
  constructor(
    private router: Router,
    private slotsDataService: SlotDataService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.appointmentDetail = this.slotsDataService.appointmentDetail;
    if (this.appointmentDetail) {
      return Observable.of(true);
    } else {
      this.appointmentCode = route.queryParams.AppointmentCode;
      let type = route.queryParams.type;
      this.router.navigate(["/slots"], {
        queryParams: { AppointmentCode: this.appointmentCode,
        type:type }
      });
      return Observable.of(false);
    }
  }
}

@Injectable()
export class IsOtherDomain implements CanActivate {
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    let hostName = window.location.host;
    let domainName = require("../../../config.json");
    if (hostName != domainName.WebUrl) {
      return true;
    }
  }
}

class EncryptDecrypt {
  static key = "OLY!@#$%^&*";
  static encrypt(string) {
    return window.btoa(string + this.key);
  }

  static decrypt(string) {
    return window
      .atob(string)
      .substring(0, window.atob(string).indexOf(this.key));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth-guard.service.ts